// @ts-check
export class TemplateUtils{
/**
 * 
 * @param {any} main 
 */
constructor(main){
    this.main = main;
}

/**
 * 
 * @param {any} data 
 * @returns 
 */
authToken(data){
  let $this = this;
    let section = this.main.pbu.createElement('section',['auth-token']);
    section.innerHTML = 
    `
    <h3 class="h3 mb-3 fw-normal sp-title">Please enter the token sent to you</h3>
    <div class="timer-banner my-4 ${this.main.pbu.showIf(data.withTimer)}">
      <p class="countdown">Session token expires in: <span class="countdown">03:00</span></p>
      <button type="button" class="btn btn-primary request-token d-none">Request another token</button>
    </div>
    ${this.main.pbu.createFormControl({clasz:['auth-token'],required:true,serialize:true})}
    <button type="button" class="btn btn-primary w-100 my-2 auth-token">Verify</button>
    `;
    //handle
    let title = section.querySelector('h3.sp-title');
    let input = section.querySelector('input.auth-token');
    let tokenButton = section.querySelector('button.auth-token');
    let countdownParagraph = section.querySelector('p.countdown');
    let countdownSpan = section.querySelector('span.countdown');
    let requestTokenButton = section.querySelector('button.request-token');
    //
    let ttl;
    let countdownInterval = null;

    if(data.withTimer){
      ttl = $this.main.config.AUTH_TOKEN_MAX_TIME;
      countdownInterval = setInterval(updateTimer, 1000);
    }


   attachEvents();
    return section;

  async function attachEvents(){
  $this.main.pbu.listen(tokenButton,'click',async()=>{
  if(! $this.main.vu.validate(input)){return;}
  //validate token
  let r = await $this.main.fu.fetch({
  link:$this.main.fu.getApi('validate-token'),
  body:JSON.stringify({tokenUuid:data.tokenUuid,token:input.value})
});

  if(r=='expired'){
    //maybe re-send token
  }else if(r=='invalid'){
    //maybe set max limit
    $this.main.utils.notify('Wrong, please try again',{level:2});
  }else if(r=='ok'){
if(data.cb){
if(data.cbIsMain){
data.component.cb = data.cb;
data.component.cb();
}else{
data.cb();
}
}
  }

  });

  $this.main.pbu.listen(requestTokenButton,'click',async()=>{
    let r = await $this.main.fu.getToken(data.email);
    if(r){
    data.tokenUuid = r;
    tokenButton.disabled = false;
    input.value = '';
    $this.main.pbu.hide(requestTokenButton);
    $this.main.pbu.show(countdownParagraph);
    ttl = $this.main.config.AUTH_TOKEN_MAX_TIME;
    countdownInterval = setInterval(updateTimer, 1000);
    }
    
  });
}//inner

  function updateTimer(){
        let minutes = Math.floor(ttl / 60);
        let seconds = ttl % 60;
        // Format numbers to always show two digits
        let paddedMinutes = String(minutes).padStart(2, '0');
        let paddedSeconds = String(seconds).padStart(2, '0');
       countdownSpan.textContent = `${paddedMinutes}:${paddedSeconds}`;
        ttl--;
        

        if (ttl<= 0) {
            clearInterval(countdownInterval);
            title.textContent = 'Token Expired';
            tokenButton.disabled = true;
            $this.main.pbu.hide(countdownParagraph);
            $this.main.pbu.show(requestTokenButton);
            $this.main.pbu.addClass(requestTokenButton,['btn-danger']);
        }
      }//inner
}//func

/**
 * 
 * @param {boolean} serialize 
 */
getModalTemplate(serialize=false){
let div = this.main.pbu.createElement('div',['prompt-modal']);
div.innerHTML = 
`
<button id="promptModalTrigger" data-bs-toggle="modal" data-bs-target="#promptModal"></button>
<div class="modal fade" id="promptModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <p class="modal-notice"></p>
        <div class="modal-body">

        </div>
        <div class="modal-footer">
          <span id="modalButton"></span>
        </div>
      </div>
    </div>
  </div>
`;
return serialize?div.outerHTML:div;
}//func

/**
 * 
 * @param {any} data 
 * @returns 
 */
getSaveButton(data){
let textContent = (data.textContent) || 'Save';
let div = this.main.pbu.createElement('div',['save-button','d-flex','justify-content-end']);
div.innerHTML = `<button type="button" class="sp-button save-button btn ${this.main.pbu.addClassIf(data.btnColor,data.btnColor,['btn-primary'])}"><i class="d-none sp-bi bi"></i>${textContent}</button>`;
let button = div.querySelector('button.save-button');
let icon = div.querySelector('i.sp-bi'); 
if(data.clasz){
  //this is the button class
  this.main.pbu.addClass(button,data.clasz);
}
if(data.divClasz){
  this.main.pbu.addClass(div,data.divClasz);
}
if(data.iconClasz){
  this.main.pbu.show(icon);
  this.main.pbu.addClass(icon,data.iconClasz);
}
if(data.style){
  button.style = data.style;
}
this.main.pbu.listen(button,'click', async ()=>{
if(!data.keepActive){
this.main.activeSaveButton = button;
button.disabled = true;
} 
//binding issues
if(data.cb){
if(data.cbIsMain){
data.component.cb = data.cb;
data.component.cb();
}else{
data.cb();
}
}
});
return div;
}//func



}//class